import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { productSearchAlgoliaAccessorGetPricingData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetPricingData'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemPriceContainerBpcReferencePrice: FC<{
  showDiscount: boolean
}> = ({ showDiscount }) => {
  const { algoliaRecord } = useProductSearchResultItemContext()
  const { isListPricePresent, listPriceFormatted } =
    productSearchAlgoliaAccessorGetPricingData(algoliaRecord)

  return isListPricePresent && listPriceFormatted && showDiscount ? (
    <div className="text-s text-dark-primary-strong">
      <span className="mr-1">
        <FormattedMessage id="product.referencePrice.label.uvp" />
      </span>
      <span>{listPriceFormatted}</span>
    </div>
  ) : null
}
